import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { APP_LINK } from "@/lib/api";
import { Icon, Sheet } from "@/components/kit";

export const HASHTAGS = "#MimikaBersih #PapaBerseri #DLHMimika #KabupatenMimika #PilahSampah";
const enc = encodeURIComponent;
const TARGETS = [
  { key: "whatsapp", label: "WhatsApp", icon: "whatsapp", color: "#25D366", href: (u, t) => `https://wa.me/?text=${enc(`${t}\n${u}`)}` },
  { key: "facebook", label: "Facebook", icon: "facebook", color: "#1877F2", href: (u) => `https://www.facebook.com/sharer/sharer.php?u=${enc(u)}` },
  { key: "x", label: "X / Twitter", icon: "twitter", color: "#111", href: (u, t) => `https://twitter.com/intent/tweet?url=${enc(u)}&text=${enc(t)}` },
  { key: "telegram", label: "Telegram", icon: "send-circle", color: "#229ED9", href: (u, t) => `https://t.me/share/url?url=${enc(u)}&text=${enc(t)}` },
  { key: "email", label: "Email", icon: "email-outline", color: "#5C6BC0", href: (u, t) => `mailto:?subject=${enc("Laporan SIAP PAPA BERSERI")}&body=${enc(`${t}\n${u}`)}` },
  { key: "instagram", label: "Instagram", icon: "instagram", color: "#E1306C" },
  { key: "tiktok", label: "TikTok", icon: "music-note", color: "#000" },
  { key: "youtube", label: "YouTube", icon: "youtube", color: "#FF0000" },
];

export const copy = async (text, msg = "Disalin") => {
  try { await navigator.clipboard.writeText(text); toast.success(msg); } catch { toast.error("Tidak dapat menyalin, salin manual"); }
};

export function ShareSheet({ open, onClose, title = "Bagikan Laporan", message, url, getUrl, cardTo, testid = "share-sheet" }) {
  const nav = useNavigate();
  const [link, setLink] = useState(url || "");
  useEffect(() => {
    if (!open) return;
    if (url) { setLink(url); return; }
    setLink("");
    getUrl?.().then(setLink).catch((e) => { toast.error(e.message); onClose(); });
  }, [open, url]); // eslint-disable-line react-hooks/exhaustive-deps
  const go = (t) => {
    if (!link) return;
    if (!t.href) return copy(`${message}\n${link}`, `Link disalin — tempel di caption, bio atau komentar ${t.label}`);
    window.open(t.href(link, message), "_blank", "noopener");
  };
  const more = () => (navigator.share ? navigator.share({ title, text: message, url: link }).catch(() => {}) : copy(`${message}\n${link}`, "Link disalin"));
  return (
    <Sheet open={open} onClose={onClose} testid={testid}>
      <div className="flex items-center gap-2"><h3 className="text-xl font-black flex-1">{title}</h3><button onClick={onClose} className="w-10 h-10 rounded-full bg-[var(--tert)]" data-testid="share-close-button"><Icon name="close" /></button></div>
      <p className="text-sm text-[var(--muted)]">Siapa pun yang membuka link dapat melihat laporan ini tanpa login.</p>
      <div className="flex gap-2 items-center rounded-2xl bg-[var(--tert)] p-2">
        <Icon name="link-variant" color="var(--brand)" />
        {link ? <span className="flex-1 truncate text-sm font-bold" data-testid="share-link-url">{link}</span> : <span className="flex-1 text-sm" data-testid="share-link-loading">Menyiapkan link…</span>}
        <button className="btn btn-soft !py-2" disabled={!link} onClick={() => copy(link, "Link disalin")} data-testid="share-copy-button"><Icon name="content-copy" size={18} />Salin</button>
      </div>
      <div className="grid grid-cols-4 gap-3 pt-1">
        {TARGETS.map((t) => (
          <button key={t.key} onClick={() => go(t)} disabled={!link} className="flex flex-col items-center gap-1 text-xs font-bold" data-testid={`share-target-${t.key}`}>
            <span className="w-12 h-12 rounded-full flex items-center justify-center text-white" style={{ background: t.color }}><Icon name={t.icon} size={24} /></span>{t.label}
          </button>))}
        <button onClick={more} disabled={!link} className="flex flex-col items-center gap-1 text-xs font-bold" data-testid="share-target-more"><span className="w-12 h-12 rounded-full flex items-center justify-center bg-[var(--tert)]"><Icon name="dots-horizontal" size={24} /></span>Lainnya</button>
      </div>
      {cardTo && <button className="btn btn-primary w-full" onClick={() => { onClose(); nav(cardTo); }} data-testid="share-card-link"><Icon name="image-frame" />Kartu Media Sosial (gambar + caption)</button>}
    </Sheet>
  );
}

let deferred = null;
if (typeof window !== "undefined") window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });

export function InstallApp() {
  const standalone = typeof window !== "undefined" && window.matchMedia?.("(display-mode: standalone)").matches;
  const [hint, setHint] = useState(false);
  const install = async () => {
    if (deferred) { deferred.prompt(); await deferred.userChoice.catch(() => {}); deferred = null; return; }
    setHint(true);
  };
  return (
    <div className="card space-y-3" data-testid="install-app-card">
      <div className="flex items-center gap-3"><span className="w-11 h-11 rounded-2xl bg-[var(--brand3)] flex items-center justify-center"><Icon name="cellphone-arrow-down" color="var(--brand)" /></span>
        <div><b className="font-black">Pakai di Laptop & HP</b><p className="text-sm text-[var(--muted)]">Buka link ini di browser laptop, Android atau iPhone, lalu masuk dengan akun yang sama.</p></div></div>
      <div className="flex gap-2 items-center rounded-2xl bg-[var(--tert)] p-2"><span className="flex-1 truncate text-sm font-bold" data-testid="install-app-link">{APP_LINK}</span>
        <button className="btn btn-soft !py-2" onClick={() => copy(APP_LINK, "Link aplikasi disalin")} data-testid="install-app-copy"><Icon name="content-copy" size={18} />Salin Link</button>
        <a className="btn !py-2 bg-[#25D366] text-white" target="_blank" rel="noreferrer" href={`https://wa.me/?text=${enc(`SIAP PAPA BERSERI – DLH Kabupaten Mimika\nBuka aplikasi: ${APP_LINK}`)}`} data-testid="install-app-share"><Icon name="whatsapp" size={18} />WhatsApp</a></div>
      {standalone ? <p className="text-sm font-bold text-[var(--brand)]" data-testid="install-app-done"><Icon name="check-circle" size={18} /> Aplikasi sudah terpasang di perangkat ini.</p>
        : <button className="btn btn-primary w-full" onClick={install} data-testid="install-app-button"><Icon name="cellphone-arrow-down" />Pasang di Perangkat Ini</button>}
      {hint && <p className="text-sm rounded-2xl bg-[var(--brand3)] p-3" data-testid="install-app-hint">Android (Chrome): menu ⋮ → <b>Tambahkan ke Layar Utama</b>. iPhone (Safari): tombol Bagikan → <b>Tambah ke Layar Utama</b>. Laptop (Chrome/Edge): ikon pasang di kanan kolom alamat.</p>}
    </div>
  );
}
